import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useStructuraAuth } from './useStructuraAuth'
import { useTranslation } from '@structura/i18n'

interface ProtectedRouteProps {
  children: React.ReactNode
}

// Component that protects routes and redirects to login if not authenticated
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const authState = useStructuraAuth()
  const location = useLocation()
  const { t } = useTranslation()

  // Show loading spinner while checking auth state
  if (authState.isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{t('auth.common.loading')}</span>
        </div>
      </div>
    )
  }

  // Redirect to account/login page if not authenticated
  if (!authState.isAuthenticated) {
    return <Navigate to="/account" state={{ from: location, message: t('nav.signInPrompt') }} replace />
  }

  // Redirect to pending activation page if account is not yet activated
  if (!authState.isActive) {
    return <Navigate to="/pending-activation" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute

